<template>
  <b-modal
    title="Format de données"
    :no-close-on-backdrop="true"
    :no-close-on-esc="true"
    :modal-class="'base-modal small-modal'"
    centered
    ref="formatPersoModal"
  >
    <b-container fluid>
      <b-form-group
        id="password-group"
        label="Format personnalisé"
        label-for="formatperso"
      >
        <input
          ref="formatperso"
          type="text"
          v-model="value"
          name="formatperso"
          class="form-control"
          placeholder="Entrez votre unité"
        />
      </b-form-group>
    </b-container>

    <div slot="modal-footer" class="w-100">
      <div class="footer-action float-right">
        <b-button
          variant="outline-primary"
          size="md"
          class="mx-2"
          @click="close"
        >
          Annuler
        </b-button>
        <b-button variant="primary" size="md" @click="upsertFormat">
          Valider
        </b-button>
      </div>
    </div>
  </b-modal>
</template>

<script>
export default {
  data () {
    return {
      isEdit: false,
      value: '',
      oldValue: '',
      id: null
    }
  },
  methods: {
    close () {
      this.isEdit = false
      this.value = ''
      this.oldValue = ''
      this.id = null
      this.$refs['formatPersoModal'].hide()
    },
    open (data) {
      this.isEdit = data.isEdit
      if (data.isEdit) {
        this.id = data.id
        this.value = data.value
        this.oldValue = data.value
      }
      this.$refs['formatPersoModal'].show()
    },
    upsertFormat () {
      if (this.isEdit) {
        this.$emit('edit', this.id, this.value, this.oldValue)
      } else {
        this.$emit('add', this.value)
      }
      this.close()
    }
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/tableau/modal/formatPerso.vue